import { CellContext } from '@tanstack/react-table'
import clsx from 'clsx'

import { UpdatedLog } from '@/types/logs'
import { format } from 'date-fns'

import styles from './UpdatedRecordsTable.module.scss'

export const TimestampValue = ({ getValue, row, column }: CellContext<UpdatedLog, string>) => {
    const value = getValue()
    const timePart = format(value, 'HH:mm')
    const datePart = format(value, 'dd/MM/yyyy')

    return (
        <div
            className={clsx(styles.updatedTimeBox, {
                [styles.updatedHighlighted]: row.original.propertiesChanged?.includes(column.id),
            })}
        >
            <span>{timePart}</span>
            <span className={styles.greyCell}>{datePart}</span>
        </div>
    )
}